export default [{
    path: 'equipment-group',
    component: () => import('@/views/dcim/equipment-group'),
    children: [{
        path: '',
        component: () => import('@/views/dcim/equipment-group/page')
    }, {
        path: 'page',
        components: { page: ()  => import('@/views/dcim/equipment-group/page') },
    }, {
        path: 'details',
        components: { details: () => import('@/views/dcim/equipment-group/details') },
    }]
}]
